import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { SharedModule } from "@shared";
import { EnquiryRoutingModule } from "./enquiry-routing.module";
import { EnquiryComponent } from "./enquiry.component";
import { TicketInformationComponent } from "./ticket-information/ticket-information.component";
import { TicketCategoryComponent } from './ticket-category/ticket-category.component';
import { NzUploadModule } from "ng-zorro-antd/upload";
import { AngularImageViewerModule } from "@clarivate/angular-image-viewer";

@NgModule({
  declarations: [EnquiryComponent, TicketInformationComponent, TicketCategoryComponent],
  imports: [
    CommonModule,
    EnquiryRoutingModule,
    ReactiveFormsModule,
    SharedModule,
    NzUploadModule,
    AngularImageViewerModule
  ],
})
export class EnquiryModule {}
